/** Theme behaviours ported from jQuery (custom.js, nav_header.js, accordeon.min.js, scroll-handler.js, analytics-events.js). */
declare global {
  interface Window {
    ym?: (...args: unknown[]) => void
    toggleMenu: () => void
    toggleaccordion_firmy: (header: HTMLElement) => void
  }
}

const METRIKA_ID = 52996714
const goal = (name: string) => window.ym?.(METRIKA_ID, 'reachGoal', name)

const fadeIn = (el: HTMLElement, ms = 500) => {
  el.style.opacity = '0'
  el.style.display = 'block'
  el.style.transition = `opacity ${ms}ms`
  requestAnimationFrame(() => (el.style.opacity = '1'))
}
const fadeOut = (el: HTMLElement, ms = 500) => {
  if (getComputedStyle(el).display === 'none') return
  el.style.transition = `opacity ${ms}ms`
  el.style.opacity = '0'
  window.setTimeout(() => (el.style.display = 'none'), ms)
}
const $$ = <T extends Element = HTMLElement>(sel: string, root: ParentNode = document) => Array.from(root.querySelectorAll<T>(sel))

/** Header: the collapsed header on scroll (inline script of the theme). */
window.toggleMenu = () => {
  const nav = document.querySelector<HTMLElement>('.section_main')
  const header = document.querySelector<HTMLElement>('.header')
  const menuThird = document.querySelector<HTMLElement>('.third_nav')
  if (!nav || !header || !menuThird) return
  const headerHeight = header.offsetHeight
  const minHeight = headerHeight - nav.offsetHeight - menuThird.offsetHeight
  header.style.top = header.style.top === `-${headerHeight}px` ? `-${minHeight}px` : `-${headerHeight}px`
}

window.toggleaccordion_firmy = (header) => {
  const content = header.nextElementSibling as HTMLElement | null
  if (!content) return
  const isOpen = content.classList.contains('open')
  $$('.accordion_firmy-content').forEach((c) => {
    c.style.maxHeight = ''
    c.classList.remove('open')
  })
  if (!isOpen) {
    content.classList.add('open')
    content.style.maxHeight = content.scrollHeight + 'px'
  }
}

function preloader() {
  const p = document.getElementById('preloader')
  if (p) window.setTimeout(() => p.classList.add('preloader-hidden'), 500)
}

function cookieNotice() {
  const banner = document.querySelector<HTMLElement>('.cookie-notice')
  if (!banner) return
  if (/(?:^|; )cookie_consent=/.test(document.cookie)) return banner.remove()
  const hide = () => {
    banner.classList.add('cookie-notice--hidden')
    window.setTimeout(() => banner.remove(), 250)
  }
  document.getElementById('cookieAcceptBtn')?.addEventListener('click', () => {
    document.cookie = `cookie_consent=1; expires=${new Date(Date.now() + 365 * 864e5).toUTCString()}; path=/`
    hide()
  })
  document.getElementById('cookieCloseBtn')?.addEventListener('click', hide)
}

function menus() {
  $$('li.mobile_menu_service, li.blue_mobile_menu').forEach((li) => li.addEventListener('click', () => li.classList.toggle('red_inside_menu')))
  // Placeholders disappear while a field is focused.
  document.addEventListener('focusin', (e) => {
    const f = e.target as HTMLInputElement
    if (!f.matches?.('input, textarea')) return
    f.dataset.placeholder = f.getAttribute('placeholder') ?? ''
    f.setAttribute('placeholder', '')
  })
  document.addEventListener('focusout', (e) => {
    const f = e.target as HTMLInputElement
    if (!f.matches?.('input, textarea') || f.dataset.placeholder === undefined) return
    f.setAttribute('placeholder', f.dataset.placeholder)
  })
}

function headerSearch() {
  const form = document.querySelector<HTMLFormElement>('#search-filter-form-32317')
  if (!form) return
  const input = form.querySelector<HTMLInputElement>('.sf-input-text')
  const lupa = document.querySelector('.lupa')
  if (input && lupa) input.before(lupa)
  form.addEventListener('submit', (e) => {
    e.preventDefault()
    const q = input?.value.trim()
    if (q) location.href = '/?s=' + encodeURIComponent(q)
  })
}

function accordions() {
  $$('.accordion').forEach((acc) =>
    acc.addEventListener('click', () => {
      $$('.accordion').forEach((other) => {
        if (other === acc) return
        other.classList.remove('active')
        const panel = other.nextElementSibling as HTMLElement | null
        if (panel?.classList.contains('panel')) panel.style.display = 'none'
      })
      acc.classList.toggle('active')
      const panel = acc.nextElementSibling as HTMLElement | null
      if (panel) panel.style.display = getComputedStyle(panel).display === 'none' ? 'block' : 'none'
    }),
  )
  const items = $$('.questions-accordion__item')
  items.forEach((item) =>
    item.querySelector('.questions-accordion__header')?.addEventListener('click', (e) => {
      if ((e.target as Element).closest('.questions-accordion__btn')) e.stopPropagation()
      items.forEach((other) => other !== item && other.classList.remove('active'))
      item.classList.toggle('active')
    }),
  )
}

/** Modal windows of the firm pages: [data-modal-open="book|ord|sell"] opens .modal[data-modal="…"]. The class hooks of the old theme still work for pages that keep them. */
function firmModals() {
  const LEGACY: Record<string, string> = { book: '.bron_form_wrap', ord: '.ord_form_wrap', sell: '.sell_form_wrap' }
  let opener: HTMLElement | null = null
  const closeAll = () => {
    $$('.modal').forEach((m) => (m.hidden = true))
    $$(Object.values(LEGACY).join(', ')).forEach((w) => fadeOut(w))
    document.body.classList.remove('modal-open')
    opener?.focus()
    opener = null
  }
  const open = (name: string, from: HTMLElement | null) => {
    const modals = $$(`.modal[data-modal="${name}"]`)
    if (modals.length) {
      closeAll()
      opener = from
      modals.forEach((m) => (m.hidden = false))
      document.body.classList.add('modal-open')
      modals[0].querySelector<HTMLElement>('input:not([type=hidden]), [data-modal-close]')?.focus()
    } else $$(LEGACY[name]).forEach((w) => fadeIn(w))
    if (name === 'book') {
      const h1 = document.querySelector('h1')?.textContent?.trim() ?? ''
      $$<HTMLInputElement>('.firm_name_for_form .bron').forEach((i) => (i.value = h1))
    }
  }
  document.addEventListener('click', (e) => {
    const t = e.target as Element
    const trigger = t.closest<HTMLElement>('[data-modal-open]')
    if (trigger) return open(trigger.dataset.modalOpen!, trigger)
    if (t.closest('.ord_firm')) open('book', null)
    else if (t.closest('.ord_sort_firm')) open('ord', null)
    else if (t.closest('.sell_my_firm')) open('sell', null)
    else if (t.closest('[data-modal-close], .cross_modal') || t.classList.contains('modal')) closeAll()
  })
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.classList.contains('modal-open')) closeAll()
  })
  $$('.desc_date').forEach((d) => {
    const s = d.textContent ?? ''
    d.textContent = `${s.slice(6, 8)}.${s.slice(4, 6)}.${s.slice(0, 4)}`
  })
  // Which license the request form is about.
  document.addEventListener('click', (e) => {
    const btn = (e.target as Element).closest<HTMLElement>('.type--list .request--btn')
    const field = document.querySelector<HTMLInputElement>("#form_license [name='request_type']")
    if (btn && field) field.value = btn.dataset.attribute ?? ''
  })
}

function scrollHandler() {
  const popup = document.querySelector<HTMLElement>('.popup')
  const header = document.querySelector<HTMLElement>('header')
  const menuThird = document.querySelector<HTMLElement>('.menu-third')
  if (!popup || !header || !menuThird) return
  window.addEventListener('scroll', () => {
    if (popup.style.display === 'block') return
    menuThird.style.zIndex = window.scrollY > header.offsetHeight ? '9999' : '1'
  })
}

/** Metrika goals: the old theme counted them on the e-mail link of its header; design A has e-mail links in the menu, footer and contacts. */
function analytics() {
  document.addEventListener('click', (e) => {
    if ((e.target as Element).closest?.('a[href^="mailto:"]')) goal('click_email')
  })
  document.addEventListener('copy', () => {
    const sel = document.getSelection()
    const node = sel?.anchorNode
    const el = node && (node.nodeType === Node.ELEMENT_NODE ? (node as Element) : node.parentElement)
    if (el?.closest('a[href^="mailto:"]') || /[\w.+-]+@[\w-]+\.[\w.-]+/.test(sel?.toString() ?? '')) goal('email_copy')
  })
  document.addEventListener('wpcf7mailsent', () => goal('send_form'))
}

/** Design A header: mobile menu, search panel, compact header pinned after scrolling past the first screen. */
function siteHeader() {
  const head = document.getElementById('site-head')
  const mnav = document.getElementById('mnav')
  const search = document.getElementById('search-panel')
  const burger = document.querySelector<HTMLElement>('[data-menu-open]')
  const setMenu = (open: boolean) => {
    if (!mnav) return
    mnav.classList.toggle('is-open', open)
    document.body.classList.toggle('menu-open', open)
    burger?.setAttribute('aria-expanded', String(open))
    if (open) mnav.querySelector<HTMLElement>('[data-menu-close]')?.focus()
    else burger?.focus()
  }
  const setSearch = (open: boolean) => {
    if (!search) return
    search.hidden = !open
    if (open) search.querySelector<HTMLInputElement>('input')?.focus()
  }
  document.addEventListener('click', (e) => {
    const t = e.target as Element
    if (t.closest('[data-menu-open]')) setMenu(true)
    else if (t.closest('[data-menu-close]')) setMenu(false)
    else if (t.closest('[data-search-open]')) setSearch(true)
    else if (t.closest('[data-search-close]') || t === search) setSearch(false)
  })
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    if (mnav?.classList.contains('is-open')) setMenu(false)
    if (search && !search.hidden) setSearch(false)
  })
  if (!head) return
  let stuck = false
  const onScroll = () => {
    const next = window.scrollY > 480
    if (next === stuck) return
    stuck = next
    head.classList.toggle('is-stuck', stuck)
    const spacer = head.nextElementSibling as HTMLElement | null
    if (spacer?.classList.contains('head-spacer') && !document.body.classList.contains('has-hero')) spacer.style.height = stuck ? `${head.offsetHeight}px` : ''
  }
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
}

/** Design A sliders: a scroll-snap track ([data-slider]) moved by the arrows of the same section. */
function scrollSliders() {
  document.addEventListener('click', (e) => {
    const btn = (e.target as Element).closest<HTMLElement>('[data-slider-prev], [data-slider-next]')
    if (!btn) return
    const track = (btn.closest('section, .slider') ?? document).querySelector<HTMLElement>('[data-slider]')
    if (!track) return
    const step = (track.firstElementChild as HTMLElement | null)?.offsetWidth ?? track.clientWidth
    track.scrollBy({ left: (btn.hasAttribute('data-slider-prev') ? -1 : 1) * (step + 20), behavior: 'smooth' })
  })
}

function yandexForms() {
  if (!document.querySelector('iframe[src*="forms.yandex.ru"]')) return
  const s = document.createElement('script')
  s.src = 'https://yastatic.net/s3/frontend/forms/_/embed.js'
  document.body.appendChild(s)
}

export function initUi() {
  preloader()
  cookieNotice()
  siteHeader()
  scrollSliders()
  menus()
  headerSearch()
  accordions()
  firmModals()
  scrollHandler()
  analytics()
  yandexForms()
}
